var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_3095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 20.5C15.0507 20.5 15.8986 20.1488 16.5237 19.5237C17.1488 18.8986 17.5 18.0507 17.5 17.1667V3.83333C17.5 2.94928 17.1488 2.10143 16.5237 1.47631C15.8986 0.85119 15.0507 0.5 14.1667 0.5L5.83333 0.5C4.94928 0.5 4.10143 0.85119 3.47631 1.47631C2.85119 2.10143 2.5 2.94928 2.5 3.83333V17.1667C2.5 18.0507 2.85119 18.8986 3.47631 19.5237C4.10143 20.1488 4.94928 20.5 5.83333 20.5H14.1667ZM4.16667 17.1667V3.83333C4.16667 3.39131 4.34226 2.96738 4.65482 2.65482C4.96738 2.34226 5.39131 2.16667 5.83333 2.16667H14.1667C14.6087 2.16667 15.0326 2.34226 15.3452 2.65482C15.6577 2.96738 15.8333 3.39131 15.8333 3.83333V17.1667C15.8333 17.6087 15.6577 18.0326 15.3452 18.3452C15.0326 18.6577 14.6087 18.8333 14.1667 18.8333H5.83333C5.39131 18.8333 4.96738 18.6577 4.65482 18.3452C4.34226 18.0326 4.16667 17.6087 4.16667 17.1667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 16.3337H13.3333C13.5543 16.3337 13.7663 16.2459 13.9226 16.0896C14.0788 15.9333 14.1666 15.7213 14.1666 15.5003C14.1666 15.2793 14.0788 15.0673 13.9226 14.9111C13.7663 14.7548 13.5543 14.667 13.3333 14.667H6.66665C6.44563 14.667 6.23367 14.7548 6.07739 14.9111C5.92111 15.0673 5.83331 15.2793 5.83331 15.5003C5.83331 15.7213 5.92111 15.9333 6.07739 16.0896C6.23367 16.2459 6.44563 16.3337 6.66665 16.3337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16665 4.66667H10.8333C11.0543 4.66667 11.2663 4.57887 11.4226 4.42259C11.5788 4.26631 11.6666 4.05435 11.6666 3.83333C11.6666 3.61232 11.5788 3.40036 11.4226 3.24408C11.2663 3.0878 11.0543 3 10.8333 3H9.16665C8.94563 3 8.73367 3.0878 8.57739 3.24408C8.42111 3.40036 8.33331 3.61232 8.33331 3.83333C8.33331 4.05435 8.42111 4.26631 8.57739 4.42259C8.73367 4.57887 8.94563 4.66667 9.16665 4.66667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_3095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bce417e1fa8a325e562c3a91083bfaa2.svg";
export { ForwardRef as ReactComponent };